import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./lookup.css";

@customElement("bp-lookup")
export class Lookup extends LitElement {
  static styles = styles;

  @property({ attribute: "anchor-position" })
  anchorPosition?: string = "bottom-left";

  @property({ attribute: "hebrew" })
  hebrew?: string;

  @property({
    type: Boolean,
    attribute: "no-animation",
    converter: (value) => (value === "true" ? true : false),
  })
  noAnimation?: boolean = false;

  @property({ attribute: "num-results" })
  numResults?: string;

  @property({ attribute: "phonetic" })
  phonetic?: string;

  @property({ attribute: "roman" })
  roman?: string;

  @property({
    type: Boolean,
    attribute: "show",
  })
  show?: boolean = false;

  render() {
    const style = this.noAnimation ? "--lookup-reveal-duration: 0;" : "";

    return html`
      <div
        style=${style}
        class="lookup ${this.show ? "shown" : "hidden"} anchor-${this
          .anchorPosition}"
      >
        <div class="background"></div>
        <span class="word"><slot></slot></span>
        <div class="box-arrow"></div>
        <div class="information-container">
          <div class="information">
            <div class="top-info">
              <bp-text-hebrew class="hebrew">${this.hebrew}</bp-text-hebrew>
              <div class="roman">${this.roman}</div>
            </div>
            <div class="bottom-info">
              <div class="phonetic">${this.phonetic}</div>
              <div class="num-results">${this.numResults} Results</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-lookup": Lookup;
  }
}
